import { useContext, useMemo, useState } from "react"
import { dateConvert } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-regular-svg-icons";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";

export const useCrad = () => {
    const { showSuccess, showError } = useContext(ToastContext);
    const [reviewPopup, setReviewPopup] = useState({
        view: false,
        data: []
    });

    const colDef = [

        { headerName: 'Employee Name', field: 'user_display_name', sortable: true, width: 140 },
        {
            headerName: 'Bid Hours',
            width: 80,
            field: 'bid_seconds',
            cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                if (params.data.hasOwnProperty(params.colDef.field)) {
                    let classN;
                    if (reviewPopup?.data?.winner_user_code === params.data.user_code) {
                        classN = "cell-color-winner";
                    }
                    if (reviewPopup?.data?.winner_user_code === params.data.user_code && reviewPopup?.data.alloted_user_code === params.data.user_code) {
                        classN = "cell-color-selected";
                    }
                    if (reviewPopup?.data?.alloted_user_code === params.data.user_code && reviewPopup?.data.winner_user_code !== params.data.user_code) {
                        classN = "cell-color-not-winner";
                    }

                    if (params.data?.submit_datetime === null) {
                        classN = "cell-color-disabled"
                    }
                    let bids = params.data?.bid_seconds / 3600;

                    return (
                        <div style={{ width: "100%" }}>
                            <div className={`estimate-cells ${classN}`}>
                                {params.data?.submit_datetime !== null && params.data?.submit_datetime !== undefined ? (
                                    <div onClick={() => { handleBidderSelect(params) }} style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "2px" }}>
                                        <span title={params.data?.bid_comment}>
                                            <FontAwesomeIcon icon="fa-solid fa-comment" style={{ marginLeft: "3px", cursor: "pointer", visibility: `${params.data?.bid_comment?.length !== 0 ? "visible" : "hidden"}` }} />
                                        </span>
                                        <span>{bids}h</span>
                                        {reviewPopup?.data?.alloted_user_code ==
                                            params.data.user_code ? (
                                            <FontAwesomeIcon icon={Icons.faCircleCheck} />
                                        ) : (
                                            <FontAwesomeIcon icon={Icons.faCircle} />
                                        )}
                                    </div>
                                ) :
                                    <>
                                        {params?.data?.is_total ?
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <span>{params.data?.bid_info}</span>
                                            </div>
                                            : <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "2px" }}>
                                                <span title={params.data?.bid_comment}>
                                                    <FontAwesomeIcon icon="fa-solid fa-comment" style={{ marginLeft: "3px", cursor: "pointer", visibility: `${params.data?.bid_comment?.length !== 0 ? "visible" : "hidden"}` }} />
                                                </span>

                                                <span>{bids}h</span>
                                                <FontAwesomeIcon icon={Icons.faCircleCheck} style={{ visibility: "hidden" }} />
                                            </div>
                                        }
                                    </>
                                }

                            </div>
                        </div>
                    );
                }
            }
        },
        { headerName: 'Comment', field: 'bid_comment', sortable: true, width: 140 },
        {
            headerName: 'Datetime', field: 'bid_datetime', sortable: true, width: 140,
            cellRenderer: (params) => {
                return <>
                    <p>{dateConvert(params.value, "date-time-month")}</p>
                </>
            }
        },
    ]
    const handleBidderSelect = async (rowdata) => {
        try {
            const payload = {
                "bucket_id": rowdata.data.bucket_id,
                "issue_id": rowdata?.data?.issue_id,
                "product_code": rowdata.data.product_code,
                "winner_user_code": reviewPopup?.data?.winner?.bid_seconds,
                "winner_bid_seconds": rowdata.value.bid_info,
                "alloted_user_code": rowdata?.data?.user_code,
                "alloted_bid_seconds": rowdata?.bid_seconds,
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTBUCKETDECLARESAVE"), payload);
            if (res) {
                if (res?.body?.StatusCode === 400 || res?.body?.StatusCode === 204 || res?.body?.StatusCode === 202 || res?.body?.StatusCode === 401 || res?.body?.StatusCode === 500) {
                    showError("error", res?.body?.errorMessage);
                    return;
                } else {
                    showSuccess("success", res?.body?.message);
                }
            }

        } catch (error) {
            console.error("Error saving bidder", error);
            showError("Error", error.response?.data?.errorMessage)
        }
    }


    return useMemo(() => ({
        reviewPopup, setReviewPopup, colDef
    }), [reviewPopup, setReviewPopup, colDef])
}